import React, { ChangeEvent, FormEvent, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BookAnsweredData,
  BookQuestion,
  BookSlot,
  BookingDetails,
  BookingList,
} from "../../store/BookingSlice";
import { RootState } from "../../store/store";
import {
  AllBookingDetails,
  Answers,
  BookForm,
  BookingLists,
  Session,
} from "../../interfaces/BookingList";
import { useParams } from "react-router";
import ReadMoreComponent from "../../components/ReadMore";
import { Tab, Tabs, TabsBody, TabsHeader } from "@material-tailwind/react";
import DatePicker, { Calendar, DateObject } from "react-multi-date-picker";
import moment from "moment";
import { ApexChart } from "../../components/Charts/LineChart";
import { generatePDF } from "../../components/GeneratePdf";

type HandleDateChangeType = (
  selectedDate: DateObject | DateObject[] | null,
  options: {
    validatedValue: string | string[];
    input: HTMLElement;
    isTyping: boolean;
  }
) => false | void;

export default function BookingsDetails() {
  const dispatch = useDispatch<any>();
  const { bookingId } = useParams<{ bookingId: string }>();
  const [activeTab, setActiveTab] = useState<number>(0);
  const [values, setValues] = useState<Date[]>([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popups, setPopups] = useState<{ [key: string]: boolean }>({});
  const [hiddenValue, setHiddenValue] = useState('hidden');
  const hiddenInputRef = useRef<HTMLInputElement>(null);

  const handleTabChange = (index: number) => {
    setActiveTab(index);
    if(index === 0){
      if (bookingId) {
        dispatch(BookingDetails(bookingId));
      }
    }
  };

  const chnageTab = (index: number) => {
    setActiveTab(index);
   
  };

  useEffect(() => {
    if (bookingId) {
      dispatch(BookingDetails(bookingId));
    }
  }, [dispatch, bookingId]);

  const bookingDetail: any = useSelector((state: RootState) => {
    return state.booking.data || ([] as AllBookingDetails[]);
  });
  const programId=bookingDetail.booking?.program?.id;
  const selectedDates =
    bookingDetail.sessions?.reduce(
      (acc: any, session: any) => {
        acc.push(new Date(session.startDate));
        return acc;
      },
      []
    ) || [];

  const handleDateChange: HandleDateChangeType = (selectedDate, options) => {
    // Handle the date change and update the state
    const convertedDates = selectedDate
      ? Array.isArray(selectedDate)
        ? selectedDate.map((dateObject) => dateObject.toDate())
        : [selectedDate.toDate()]
      : [];

    setValues(convertedDates);
    const formattedDates = convertedDates.map((date) =>
      moment(date).format("YYYY-MM-DD")
    );

    openPopup(formattedDates);
  };

  const openPopup = (id: any) => {
    setPopups({ ...popups, [id]: true });
  };

  const closePopup = (id: any) => {
    setPopups({ ...popups, [id]: false });
  };

  const activeDates: Date[] =
    bookingDetail.counsellingBookings?.reduce((acc: Date[], booking: any) => {
      if (booking.counselling && booking.counselling.date) {
        acc.push(new Date(booking.counselling.date));
      }
      return acc;
    }, []) || [];

  const [radioValue, setRadiovalue] = useState("");
  const changeSelection = (e: any) => {
    setRadiovalue(e.target.value);
  };

  const handleSubmit = (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault();

    dispatch(BookSlot(radioValue))
      .then(() => {
        //closePopup();
        window.location.reload();

      })
      .catch((err: { message: any }) => {
        if (err instanceof Error) {
          console.error(err.message);
        }
      });
  };

  const mergedArray = [
    ...(bookingDetail?.sessions ?? []),
    ...(bookingDetail?.counsellingBookings ?? []),
  ];


  // Sort mergedArray by start date/time
  const sortedArray = [...mergedArray].sort((a, b) => {
    const dateA = moment(a.startDate ?? a.counselling.date);
    const dateB = moment(b.startDate ?? b.counselling.date);
    return dateA.valueOf() - dateB.valueOf(); // Use valueOf() to compare moments
  });
  
  const [answers, setAnswers] = useState<{ id: string; ans: string; selectedOption?: string | null; questionAskedId?: string;}[]>([]);

  const handleQuestionsSubmit = async (ev: FormEvent<HTMLFormElement>) => {
    ev.preventDefault();    
    
    dispatch(BookQuestion({ answers, programId }))
    .then(() => {
      setActiveTab(1);
      setAnswers([]);
      dispatch(BookAnsweredData(programId));  
  
    },[dispatch,answers, programId ])
  };
  const handleRadioChange = (id: string,questionAskedId: string, ans: string, value: string) => {
    const updatedAnswers = answers.map((answer) => {
      if (answer.questionAskedId === questionAskedId) {
        const selectedOptionTitle = bookingDetail?.questions
          .find((question: any) => question.id === id)
          ?.options.find((option: any) => option._id === value)?.title || '';
          // const questionAskedId =bookingDetail?.questions
          // .find((question: any) => question.id === id)?.questionAskedId || '';
          
        return { ...answer, selectedOption: value, ans: ans, questionAskedId: questionAskedId };
      }
      return answer;
    });
    if (updatedAnswers.some((answer) => answer.questionAskedId === questionAskedId)) {
      setAnswers(updatedAnswers);
    } else {  
      // const questionAskedId =bookingDetail?.questions
      // .find((question: any) => question.id === id)?.questionAskedId || '';
      
      setAnswers([...updatedAnswers, { id, ans: ans, selectedOption: value, questionAskedId: questionAskedId }]);
    }
  };
  
  
  const handleTextareaChange = (id: string,questionAskedId: string, value: string) => {
    
    const updatedAnswers = answers.map((answer) => {
      if (answer.questionAskedId === questionAskedId) {
        //  const questionAskedId =bookingDetail?.questions
        //  .find((question: any) => question.id === id)?.questionAskedId || '';
        
        return { ...answer, ans: value, questionAskedId: questionAskedId };
      }
      return answer;
    });
    if (updatedAnswers.some((answer) => answer.questionAskedId === questionAskedId)) {
      setAnswers(updatedAnswers);
    } else {
      //  const questionAskedId =bookingDetail  ?.questions
      //  .find((question: any) => question.id === id)?.questionAskedId || '';
      
      setAnswers([...updatedAnswers, { id, ans: value, questionAskedId: questionAskedId }]);
    }
  };
  
  useEffect(() => {    
    if(bookingDetail?.booking?.program.id){
        dispatch(BookAnsweredData(programId));    
    }
    }, [dispatch, programId ]);

      const allAnswers: any = useSelector((state: RootState) => {
        return state.booking.data1;
      });

      const handleButtonClick = () => {
        const paymentDetails = {
            date: bookingDetail.booking.paymentDate,
            amount: bookingDetail.booking.amount,
            paymentReferenceId: bookingDetail.booking.paymentReferenceId,
            programName: bookingDetail.booking.program.title
        };
        generatePDF(paymentDetails);
    };

   return (
    <>
      <div className="flex flex-wrap align-middle">
        {" "}
        <a href="/bookings/">
          <svg
            width="25"
            height="20"
            viewBox="0 0 25 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mt-2 mr-4 ml-4"
          >
            <path
              d="M0.999702 10.0001L23.4082 10.0001"
              stroke="#95A8B1"
              stroke-width="1.9"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M10.0381 19L0.999992 10.0007L10.0381 1"
              stroke="#95A8B1"
              stroke-width="1.9"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>

            <h1 className="mb-4 text-3xl text-[#041B44] h-[40px]">My Bookings</h1>
        
      </div>
      <div className="justify-start  h-[calc(100vh-226px)] overflow-y-scroll scrollbar-hide p-4">
        <div className="flex flex-wrap ">
          {bookingDetail.booking?.program?.hasCounselling !== false && (
        <div className="w-full md:w-[52%] xl:w-auto ">
          <div className="shadow-[0_4px_6px_4px_rgb(0,0,0,0.1),0_2px_4px_-2px_rgb(0,0,0,0.1)] rounded-lg p-6 bg-white h-[460px]">
            <h2 className="uppercase font-semibold text-xl md:text-2xl text-[#020220] tracking-wide mb-4">
              Counselling slots <span className="text-lg text-[#037897] float-right">    {bookingDetail.counsellingBookings ? bookingDetail.counsellingBookings.length : 0}/{bookingDetail.booking?.program?.totalCounsellings}</span>
            </h2>

            <Calendar
              key="uniqueKey"
              minDate={new Date()}
              highlightToday={false}
              onChange={
                handleDateChange as unknown as (
                  selectedDate: DateObject | DateObject[] | null
                ) => false | void
              }
              className={`day-contents `}
              mapDays={({ date }) => {
                let className;
                const strDate = moment(date.toDate()).format("YYYY-MM-DD");

                selectedDates.forEach((selectDate: any) => {
                  if (moment(selectDate).format("YYYY-MM-DD") === strDate) {
                    className = "active";
                  }
                });
                activeDates.forEach((activeDate) => {
                  if (moment(activeDate).format("YYYY-MM-DD") === strDate) {
                    className = "active reserved";
                  }
                });
                if (className) return { className };
              }}
            />
            <span className="text-sm text-[#037897] p-5 mt-6">  Select date to book your 1-1 counselling.</span>
          </div>

          {bookingDetail.counsellings?.counselingSessions &&
            bookingDetail.counsellings?.counselingSessions?.map(
              (counselling: any) => (
                <div key={counselling.date}>
                  {popups[counselling.date] && (
                    <div className="popup-overlay relative z-[100]">
                      <div className="w-[32%] bg-white rounded-lg p-6">
                        <div className="relative mb-8">
                          <div id={counselling.date} className="popup">
                            <form onSubmit={handleSubmit}>
                              <div className="flex flex-wrap gap-1 mb-4 py-4">
                                <h3 className="text-lg font-semibold w-full mb-4 p-2">Date: {moment.utc(counselling.date).format("DD/MM/YYYY")}</h3>
                                {counselling.slots.map((slot: any) => (
                                  <div key={slot.id} className="mb-6">
                                    <input
                                      type="radio"
                                      id={slot.id}
                                      name="amount"
                                      className="hidden absolute w-32 p-6 h-4 bookbtn"
                                      value={slot.id}
                                      onChange={changeSelection}
                                      checked={radioValue === slot.id}
                                      disabled={slot.isBooked === true}
                                    />
                                    <label
                                      htmlFor={slot.id}
                                      className={`md:basis-1/5 border w-auto h-12 min-w-36 px-6 justify-center py-3  text-[#041B44] rounded-lg m-2 border-[#041B44] ${
                                        slot.isBooked === true
                                          ? "bg-[#C7C7C7] text-[#000000] border-[#C7C7C7]"
                                          : "bg-white cursor-pointer hover:bg-[#041B44] hover:text-white  "
                                      }`}
                                    >
                                      {moment.utc(slot.time).format("hh:mm A")}
                                    </label>
                                  </div>
                                ))}
                              </div>
                              <div className="w-full">
                                <button
                                  type="submit"
                                  className="bg-[#B4804A] font-gilroy w-32 text-white py-2 px-4 font-semibold rounded-md focus:outline-none border-[#E7EFF3] border-2 focus:border-gray-500"
                                >
                                  Save
                                </button>
                              </div>
                            </form>
                            <button
                              onClick={() => closePopup(counselling.date)}
                              className="absolute -top-3  right-0"
                            >
                              X
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )
            )}
          </div>
          )}
          <div className="md:w-[2%] xl:w-[3%]"></div>
          <div className="w-full md:w-[46%] xl:w-[55%] mt-10 md:mt-0">
          <div className="w-full shadow-[0_4px_6px_4px_rgb(0,0,0,0.1),0_2px_4px_-2px_rgb(0,0,0,0.1)] rounded-lg p-6 bg-white h-[460px]">
          <span>Statistics </span>
   
            <ApexChart  AnserData={allAnswers}/>
          </div>
          </div>
        </div>


        <div className="flex w-full shadow-[0_4px_6px_4px_rgb(0,0,0,0.1),0_2px_4px_-2px_rgb(0,0,0,0.1)] rounded-lg p-2 md:p-6 bg-white mt-10">
          <Tabs>
            <TabsHeader className="border-b-2  rounded-none mx-4 ">
              <Tab
                key="Basic"
                value="Basic"
                onClick={() => handleTabChange(0)}
                className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 uppercase ${
                  activeTab === 0 ? "active border-[#037897]" : ""
                }  `}
              >
                Pending
              </Tab>
              <Tab
                key="Sessions"
                value="Sessions"
                onClick={() => handleTabChange(1)}
                className={`w-48 text-[#B0BEC5] border-b-2 custom-mb-minus-5 uppercase  ${
                  activeTab === 1 ? "active border-[#037897]" : ""
                }  `}
              >
                Answered
              </Tab>
            </TabsHeader>

            <TabsBody className="m-2 md:m-4 p-2">
              <div
                className={activeTab === 0 ? "tab-panel active" : "tab-panel"}
              >
               <form onSubmit={handleQuestionsSubmit}>
                  {activeTab === 0 &&
                    bookingDetail?.questions &&
                    bookingDetail?.questions.map((question: any, questionIndex: any) => (
                      <li className={`list-disc list-outside mt-2 marker:text-[#037897] text-xl  ${question.type === "Text" ? "mb-4 " : "mb-8 "}`} key={questionIndex + 1}>
                      
                      <span className="text-[#6B7D86] -ml-2 pr-3 text-lg ">Q: {questionIndex + 1}</span>
                      <h3 className="text-lg basis-4/12 pr-2 inline  pt-3 md:pt-0">{question.text} <span className="float-right text-base pr-6"><b>Date:</b> {moment.utc(question.askedOn).format("DD-MM-YYYY")}</span></h3>
                      <div className={`ml-4  ${question.type === "Text" ? "my-2 " : "my-4 "}`}>
                        
                          {question.type === "Text" ? (
                           <textarea
                           className="border-[#DAE2E7] border rounded-md bg-[#F9FAFB] w-[95%] px-4 py-3"
                           name={question.questionAskedId}
                           defaultValue={answers.find((answer) => answer.questionAskedId === question.questionAskedId)?.ans || ""}
                           onChange={(e) => handleTextareaChange(question.id,question.questionAskedId, e.target.value)}
                         ></textarea>
                          ) : (
                            question?.options &&
                            question?.options.map((option: any, optionsIndex: any) => (
                              <div key={option.id} className="mb-6 inline">
                              <input
                                type="radio"
                                id={option.id+question.questionAskedId}
                                name={question.questionAskedId}
                                className="hidden absolute w-32 p-6 h-4 bookbtn"
                                value={option.id}
                                onChange={() => handleRadioChange(question.id,question.questionAskedId, option.title, option.id)}
                               
                              />
                              <label
                                htmlFor={option.id+question.questionAskedId}
                                className="font-gilroy bg-[#F5F7F8] text-sm md:text-base text-[#657F8B] font-medium me-2 px-3 py-2 md:px-6 md:py-3 rounded-full border-1"
                              >
                                {option.title}
                              </label>
                            </div>
                            ))
                          )}
                        </div>
                      </li>
                    ))}
                    {activeTab === 0 &&
                  <button
                    type="submit"
                    className="mt-6 px-8 py-3 bg-[#037897] font-semibold uppercase text-white rounded-md"
                  >
                    Save
                  </button>
                      }
                </form>
                
              </div>

              <div
                className={activeTab === 1 ? "tab-panel active" : "tab-panel"}
              >
                {activeTab === 1 &&
                    allAnswers &&
                    allAnswers.map(
                    (answer: any, answerIndex:any) => (
                     
                      <li className={`list-disc  list-outside mt-2 marker:text-[#037897] text-xl  ${answer.questionType === "Text" ? "mb-4 " : "mb-8 "}`} key={answerIndex + 1}>
                        <span className="text-[#6B7D86] -ml-2 pr-3 text-lg ">Q: {answerIndex + 1}</span>
                        <h3 className="text-lg basis-4/12 pr-2 inline  pt-3 md:pt-0">{answer.questionText} 
                        {/* <span className="float-right text-base pr-6"><b>Answerd Date:</b> {moment.utc(answer.answeredOn).format("DD-MM-YYYY")}</span>  */}
                        <span className="float-right text-base pr-6"><b> Asked Date:</b> {moment.utc(answer.askedOn).format("DD-MM-YYYY")}</span></h3>
                        <div className={`ml-2 md:ml-4  ${answer.questionType === "Text" ? "my-2 " : "my-2 md:my-4 "}`}>
                          {answer.questionType === "Text" ? (
                           <textarea
                           className="border-[#DAE2E7] border rounded-md bg-[#F9FAFB] w-[95%] px-4 py-3"
                           name={answer.id}
                           defaultValue={answer.ans || ""}                           
                         ></textarea>
                          ) : (
                            answer?.questionOptions &&
                            answer?.questionOptions .map((option: any, optionsIndex: any) => (
                              <div key={option.id} className="mb-6 inline">
                              <input
                                type="radio"
                                id={option.id}
                                name={answer.id}
                                className="hidden absolute w-32 p-6 h-4 bookbtn"
                                value={option.id}
                               disabled
                              />
                              <label
                                htmlFor={option.id}
                                className={`font-gilroy font-medium me-2 px-6 py-3 rounded-full border-1 ${option.id === answer.selectedOption ? "bg-[#041B44] text-[#ffffff]" : "bg-[#F5F7F8] text-[#657F8B]"}`}
                              >
                                {option.title}
                              </label>
                            </div>
                            ))
                          )}
                        </div>
                      </li>
                    )
                  )} 
              </div>
            </TabsBody> 
          </Tabs>
        </div>

        <div className="container progress mx-auto my-4 relative items-center py-8">
          <h2 className="uppercase font-semibold text-xl md:text-2xl text-[#020220] tracking-wide	mb-6">
            online session
          </h2>

          {sortedArray.map((session, sessionIndex) => (
            <>
              {session.counselling && (
                <div className={sessionIndex === sortedArray.length - 1 ? "last w-full" : "w-full"}>
                <div className="circle active"></div>
                <div className=" rounded-lg shadow-[0_4px_6px_4px_rgb(0,0,0,0.1),0_2px_4px_-2px_rgb(0,0,0,0.1)] ml-8 mb-4">
                <div className="flex flex-col md:flex-row align-middle items-center min-h-[7rem]  p-2">
                  <div className="basis-full md:basis-2/12 md:border-r min-h-[5.2rem] text-center border-[#C2C2C2]">
                    <span className="text-3xl 2xl:text-4xl font-bold text-[#B4804A]">
                        {moment.utc(session.counselling.date).format("DD")}
                      </span>
                      <p className="text-xl font-semibold">
                        {" "}
                        {new Date(
                          session.counselling.date ?? ""
                        ).toLocaleDateString("en-US", { month: "long" })}
                      </p>
                    </div>
                    <div className="basis-full md:basis-6/12 flex flex-col md:flex-row  px-2 pl-2 md:pl-6 py-2 justify-center border-t  border-b md:border-0">
                      <h3
                        key={sessionIndex}
                        className="text-xl basis-4/12 pr-2 font-semibold pt-3 md:pt-0"
                      >
                        Counselling
                      </h3>

                      <p className="text-[#546E7A] basis-8/12 pr-4 ">
                        Booked Counselling
                      </p>
                    </div>
                    <div className="basis-full md:basis-4/12 md:border-l min-h-[5.2rem] text-center border-[#C2C2C2] p-2 flex  items-center justify-center">
                      <p className="text-base font-semibold">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 28 28"
                          className="inline mr-1"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M27 14C27 21.1802 21.1802 27 14 27C6.81978 27 1 21.1802 1 14C1 6.81978 6.81978 1 14 1C21.1802 1 27 6.81978 27 14Z"
                            stroke="#B4804A"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M18.8218 18.1351L13.5234 14.9744V8.16235"
                            stroke="#B4804A"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        {moment.utc(session.counselling.time).format("hh:mm A")}{" "}
                        to{" "}
                        {moment
                          .utc(session.counselling.endTime)
                          .format("hh:mm A")}
                     <a href={bookingDetail.booking?.program?.counsellingLink} className="uppercase px-4 2xl:px-6 py-3 bg-[#B4804A] text-white rounded-md ml-2">Join</a>

                      </p>
                    </div>
                  </div>
                </div>
                <span className="bar active"></span>
                </div>
              )}
               
               {session.startDate && (
                <div className={sessionIndex === sortedArray.length - 1 ? "last w-full" : "w-full"}>
              <div className="circle done"></div>
               <div className="rounded-lg shadow-[0_4px_6px_4px_rgb(0,0,0,0.1),0_2px_4px_-2px_rgb(0,0,0,0.1)] ml-8 mb-4">
                <div className="flex flex-col md:flex-row align-middle items-center min-h-[7rem]  p-2">
                  <div className="basis-full md:basis-2/12 md:border-r min-h-[5.2rem] text-center border-[#C2C2C2]">
                    <span className="text-3xl 2xl:text-4xl font-bold text-[#037897]">
                      {new Date(session.startDate ?? "").toLocaleDateString(
                        "en-US",
                        { day: "numeric" }
                      )}
                    </span>
                    <p className="text-xl font-semibold">
                      {" "}
                      {new Date(session.startDate ?? "").toLocaleDateString(
                        "en-US",
                        { month: "long" }
                      )}
                    </p>
                  </div>
                  <div className="basis-full md:basis-6/12 flex flex-col md:flex-row  px-2  md:pl-6 py-2 justify-center border-t  border-b md:border-0">
                    <h3
                      key={sessionIndex}
                      className="text-xl  basis-4/12 pr-2 font-semibold pt-3 md:pt-0"
                    >
                      {session.title}
                    </h3>

                    <p className="text-[#546E7A] basis-8/12 pr-4 ">
                      <ReadMoreComponent
                        text={session?.description ?? ""}
                        maxLength={100}
                      />
                    </p>
                  </div>
                  <div className="basis-full md:basis-4/12 md:border-l min-h-[5.2rem] text-center border-[#C2C2C2] 2xl:p-2 flex  items-center justify-center">
                    <p className="text-base 2xl:text-lg font-semibold">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 28 28"
                        className="inline mr-1"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M27 14C27 21.1802 21.1802 27 14 27C6.81978 27 1 21.1802 1 14C1 6.81978 6.81978 1 14 1C21.1802 1 27 6.81978 27 14Z"
                          stroke="#037897"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.8218 18.1351L13.5234 14.9744V8.16235"
                          stroke="#037897"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>{" "}
                      {new Date(session.startTime ?? "").toLocaleTimeString(
                        "en-US",
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                        }
                      )}{" "}
                      to{" "}
                      {new Date(session.endTime ?? "").toLocaleTimeString(
                        "en-US",
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                        }
                      )}
                      <a href={bookingDetail.booking?.program?.zoomLink} className="uppercase px-4 2xl:px-6 py-3 bg-[#037897] text-white rounded-md ml-2">Join</a>

                    </p>
                  </div>
                </div>
              </div>
              <span className="bar done"></span>
              </div>
              
              )}               
            </>
          ))}
        </div>
        {"booking" in bookingDetail &&
          bookingDetail.booking &&
          typeof bookingDetail.booking === "object" && (
            <>
              {"program" in bookingDetail.booking && (
                <div className="flex flex-wrap shadow-[0_4px_6px_4px_rgb(0,0,0,0.1),0_2px_4px_-2px_rgb(0,0,0,0.1)] rounded-lg p-6 bg-white">
                  <div className="w-full md:w-1/2 p-4">
                    <h2 className="font-semibold text-2xl md:text-4xl capitalize text-[#020220] tracking-wide mt-2 mb-8 hidden md:block">
                      {(bookingDetail.booking as BookingLists)?.program
                        ?.title || "Default Title"}
                    </h2>
                    <p className="mb-4 text-[#546E7A]">
                      <ReadMoreComponent
                        text={
                          (bookingDetail.booking as BookingLists)?.program
                            ?.description ?? ""
                        }
                        maxLength={300}
                      />
                    </p>
                    {/* <div className="">
                      <div className="rounded-lg basis-6/12  p-4 mb-6 bg-[#F9FAFB]  border border-[#DAE2E7]">
                        <p className="text-[#607D8B] mb-2">Date</p>
                        <p className="text-xl">{ new Intl.DateTimeFormat("en-US", {
                            weekday: "short",
                            year: "numeric",
                            month: "short",
                          }).format(new Date((bookingDetail.booking as BookingLists)?.program
                          ?.startDate))   }</p>
                      </div>
                    </div>
                    <div className="flex  gap-6">
                      <div className="rounded-lg basis-6/12  p-4 mb-6 bg-[#F9FAFB]  border border-[#DAE2E7]">
                        <p className="text-[#607D8B] mb-2">Booked Slots</p>
                        <p className="text-xl">0</p>
                      </div>
                      <div className="rounded-lg basis-6/12  p-4 mb-6 bg-[#F9FAFB]  border border-[#DAE2E7]">
                        <p className="text-[rgb(96,125,139)] mb-2">
                          Total Counsellings
                        </p>
                        <p className="text-xl">
                          {
                            (bookingDetail.booking as BookingLists)?.program
                              ?.totalCounsellings
                          }
                        </p>
                      </div>
                    </div> */}
                    <button className="uppercase bg-[#037897] text-white py-4 leading-3 font-bold rounded-md px-8" onClick={handleButtonClick}>
                      <svg
                        width="25"
                        height="23"
                        viewBox="0 0 25 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="inline mr-2"
                      >
                        <path
                          d="M12.2493 15.6445L12.2493 1"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.7959 12.0835L12.2494 15.6446L8.70293 12.0835"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M17.8847 6.75635H19.0195C21.4945 6.75635 23.5 8.76189 23.5 11.2381L23.5 17.1781C23.5 19.647 21.4993 21.6477 19.0304 21.6477L5.48176 21.6477C3.00676 21.6477 1 19.6409 1 17.1659L1 11.2247C1 8.75702 3.00189 6.75635 5.46959 6.75635L6.61527 6.75635"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Download receipt
                    </button>
                  </div>
                  
                  <div className="w-full md:w-1/2 p-4">
                    <img
                      src={
                        (bookingDetail.booking as BookingLists)?.program?.icon
                      }
                      alt=""
                      className="h-full w-auto object-cover rounded-lg"
                    />
                  </div>
                </div>
              )}
            </>
          )}
      </div>
    </>
  );
}
